import { createFileRoute } from "@tanstack/react-router";
import DifferenceBipolar1AndBipolar2Page from "@/pages/articles/DifferenceBipolar1AndBipolar2Page";
export const Route = createFileRoute("/difference-bipolar-1-and-bipolar-2")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Bipolar 1 vs Bipolar 2 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn the key clinical differences between Bipolar 1 (full manic episodes) and Bipolar 2 (hypomania & depression), diagnosis criteria, and advanced.",
        },
        {
          property: "og:title",
          content: "Bipolar 1 vs Bipolar 2 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn the key clinical differences between Bipolar 1 (full manic episodes) and Bipolar 2 (hypomania & depression), diagnosis criteria, and advanced.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-is-the-difference-between-bipolar-1-and-bipolar-2",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-the-difference-between-bipolar-1-and-bipolar-2",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DifferenceBipolar1AndBipolar2Page />;
}
